export default "data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAACwAQCdASoFAAYAAgA0JQBOgCHhzLywAP6mayxM7puS4urom/lmcNeOGhjFtJ/gAAA="